module.exports = __webpack_public_path__ + "static/media/1015174.9f3536d0.jpg";